import { inject, Injectable, signal, WritableSignal } from '@angular/core';
import { take } from 'rxjs';
import { IEducationLevelGroup } from '../../api/mylb/interfaces/ieducation-level-group.interface';
import { IEducationLevel } from '../../api/mylb/interfaces/ieducation-level.interface';
import { IGender } from '../../api/mylb/interfaces/igender.interface';
import { IPronoun } from '../../api/mylb/interfaces/ipronoun.interface';
import { SystemDataService } from '../../api/mylb/services/system-data.service';

@Injectable()
export class ProfileSupportDataStateService {
	private _systemDataService: SystemDataService = inject(SystemDataService);

	public loaded: WritableSignal<boolean> = signal(false);
	public pronouns: WritableSignal<IPronoun[]> = signal<IPronoun[]>([]);
	public genders: WritableSignal<IGender[]> = signal<IGender[]>([]);
	public educationLevels: WritableSignal<IEducationLevel[]> = signal<IEducationLevel[]>([]);
	public educationLevelGroups: WritableSignal<IEducationLevelGroup[]> = signal<IEducationLevelGroup[]>([]);

	constructor() {
		this.loadProfileSupportData();
	}

	loadProfileSupportData(): void {
		this.loaded.set(false);
		this._systemDataService
			.getProfileSupportData()
			.pipe(take(1))
			.subscribe({
				next: (profileSupportData) => {
					this.pronouns.set(profileSupportData.pronouns);
					this.genders.set(profileSupportData.genders);
					this.educationLevels.set(profileSupportData.educationLevels);
					this.educationLevelGroups.set(profileSupportData.educationLevelGroups);
					this.loaded.set(true);
				}
			});
	}
}
